import { projectsData } from "../data";
import Project from "./Project";

const Projects = () => {
  return (
    <section className="grid gap-16 lg:grid-cols-2">
      {projectsData.map((item) => (
        <Project item={item} key={item.id} />
      ))}
    </section>
  );
};

export default Projects;
